export const LAST_USER_INTERACTION_LOCAL_STORAGE_KEY = 'lastUserInteraction';
